import React, { FC, PropsWithChildren } from 'react';
import { useAuth } from 'services/authentication';

const RequireAdmin: FC<PropsWithChildren> = ({ children }) => {
    const { user } = useAuth();

    if (user?.permissions.role !== 'admin') {
        throw new Response('Not Found', { status: 404, statusText: 'Not Found' });
    }

    return <>{children}</>;
};

export default RequireAdmin;
